module.exports = __webpack_public_path__ + "img/feature4.adbe86c0.png";